if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    #intersectionObserver = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0]?.isIntersecting) return;

        observer.disconnect();
        this.#onVisible();
      },
      {
        rootMargin: '0px 0px 400px 0px',
      }
    );

    constructor() {
      super();

      this.currentHandle = this.dataset.productHandle;
      this.maxHistory = Number(this.dataset.max) || 10;
    }

    connectedCallback() {
      this.#intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.#intersectionObserver.disconnect();
    }

    #saveCurrentProduct() {
      if (!window.localStorage || !this.currentHandle) return;

      let products = [];

      try {
        products = JSON.parse(
          localStorage.getItem('recently-viewed') || '[]'
        );

        if (!Array.isArray(products)) {
          products = [];
        }
      } catch {
        products = [];
      }

      products = products.filter(
        (handle) => handle !== this.currentHandle
      );

      products.unshift(this.currentHandle);

      products = products.slice(
        0,
        this.maxHistory
      );

      localStorage.setItem(
        'recently-viewed',
        JSON.stringify(products)
      );
    }

    #getRecentlyViewedProducts() {
      if (!window.localStorage) return [];

      try {
        const products = JSON.parse(
          localStorage.getItem('recently-viewed') || '[]'
        );

        return Array.isArray(products)
          ? products
          : [];
      } catch {
        return [];
      }
    }

    #onVisible() {
      const products = this.#getRecentlyViewedProducts();

      if (products.length) {
        this.#loadProducts(products);
      }

      this.#saveCurrentProduct();
    }

    async #loadProducts(products) {
      const query = products
        .map((handle) => `handle:${handle}`)
        .join(' OR ');

      const url =
        `${this.dataset.url}?section_id=${this.dataset.sectionId}` +
        `&type=product&q=${encodeURIComponent(query)}`;

      const response = await fetch(url);
      const html = await response.text();

      const parser = document.createElement('div');
      parser.innerHTML = html;

      const newSection = parser.querySelector(
        `#${this.id}`
      );

      if (newSection) {
        this.innerHTML = newSection.innerHTML;
      }
    }
  }

  customElements.define(
    'recently-viewed-products',
    RecentlyViewedProducts
  );
}